export enum DiscountType {
  /** Dollar amount off each unit. */
  EACH = "d$",
  /** Fixed dollar amount off the line. */
  TOTAL = "dT",
  /** Percent off each unit (× discount qty). */
  PERCENT = "d%",
  /** Percent off the line total (unit × qty). */
  PERCENT_TOTAL = "d%T",
}
